angular.module("app").directive("fashionFrequentColorsAcrossSeasonsChart", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbFashionFrequentColorsAcrossRegions/dbFashionFrequentColorsAcrossRegionsView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
